import { getCitiesHandler } from './get-cities.handler'
import { getPatientResultsHandler } from './get-patient-results.handler'
import { getTemplatesHandler } from './get-templates.handler'
import { getDiagnosesHandler } from './get-diagnoses.handler'
import { gridcardHandler } from './gridcard.handler'
import { loginHandler } from './login.handler'
import { openRequestsByBirthNumberHandler } from './open-requests-by-birth-number.handler'
import { openResultsByBirthNumberHandler } from './open-results-by-birth-number.handler'
import { prefillRequestHandler } from './prefill-request.handler'
import { logoutHandler } from './logout.handler'
import { withAccessContext } from './resolve-access-from-params'
import type { TokenHandshakeHandler } from './types'

export const tokenHandshakeHandlers: Record<string, TokenHandshakeHandler> = {
	login: loginHandler,
	gridcard: gridcardHandler,
	logout: logoutHandler,
	getTemplates: withAccessContext(getTemplatesHandler),
	getDiagnoses: withAccessContext(getDiagnosesHandler),
	getCities: withAccessContext(getCitiesHandler),
	getPatientResults: withAccessContext(getPatientResultsHandler),
	openRequestsByBirthNumber: withAccessContext(openRequestsByBirthNumberHandler),
	openResultsByBirthNumber: withAccessContext(openResultsByBirthNumberHandler),
	prefillRequest: withAccessContext(prefillRequestHandler)
}

export * from './types'
